var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smk-job-forms-main"},[_c('DesignerV2',{attrs:{"viewMode":true,"reportFile":_vm.designerV2ReportFile,"reportFolder":"ROTForm","reportData":_vm.designerV2ReportData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }